module.exports = __webpack_public_path__ + "img/office-building.4e662f00.png";